import Overlay from './Overlay';
import OverlayContainer from './Overlay.container';
import OverlayV2 from '../Overlay.cdc_new_thumbs';
import { withFeatureBranch } from '../../../../redux/flags';
export default withFeatureBranch({
    cdc_new_thumbs: OverlayV2,
})(OverlayContainer(Overlay));
//# sourceMappingURL=index.js.map